require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-use-headings-to-show-hierarchical-relationships-of-content.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-use-headings-to-show-hierarchical-relationships-of-content");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-use-headings-to-show-hierarchical-relationships-of-content!./.cache/json/responsive-web-design-applied-accessibility-use-headings-to-show-hierarchical-relationships-of-content.json
// module id = 2519
// module chunks = 231608221292675